import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { TabBarComponent } from './tab-bar/tab-bar.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DialogComponent } from './dialog/dialog.component';
import { GenTimesheetDialogComponent } from './gen-timesheet-dialog/gen-timesheet-dialog.component';
import { DialogDevicesComponent } from './dialog-devices/dialog-devices.component';
import { WebcamModule } from 'ngx-webcam';
import { MatExpansionModule } from '@angular/material/expansion';
import { DialogLeaveComponent } from './dialog-leave/dialog-leave.component';
import { DialogEmployeeTimesheetComponent } from './dialog-employee-timesheet/dialog-employee-timesheet.component';
import { DialogLoanComponent } from './dialog-loan/dialog-loan.component';
import { DialogPaidLoanComponent } from './dialog-paid-loan/dialog-paid-loan.component';
import { DialogExpenseComponent } from './dialog-expense/dialog-expense.component';
import { DialogWorkdaysComponent } from './dialog-workdays/dialog-workdays.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { AboutComponent } from './about/about.component';
import { DialogEmployeeDeleteComponent } from './dialog-employee-delete/dialog-employee-delete.component';
import { DialogEmployeeDetailsComponent } from './dialog-employee-details/dialog-employee-details.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DialogRemittSsoComponent } from './dialog-remitt-sso/dialog-remitt-sso.component';
import { ModalImportEmployeeComponent } from './modal-import-employee/modal-import-employee.component';
import { ModalPlanRenewComponent } from './modal-plan-renew/modal-plan-renew.component';
import { AlertComponent } from './alert/alert.component';
import { Alert } from 'bootstrap';
import { DialogDefinitionComponent } from './dialog-definition/dialog-definition.component';
import { DialogAddConceptsComponent } from './dialog-add-concepts/dialog-add-concepts.component';
import { MatRadioModule } from '@angular/material/radio';
import { DialogDeleteConceptComponent } from './dialog-delete-concept/dialog-delete-concept.component';
import { DialogAddYearComponent } from './dialog-add-year/dialog-add-year.component';
import { DialogDeleteYearComponent } from './dialog-delete-year/dialog-delete-year.component';
import { DialogCreatePeriodsComponent } from './dialog-create-periods/dialog-create-periods.component';
import { DialogDeleteYearBatchComponent } from './dialog-delete-year-batch/dialog-delete-year-batch.component';
import { DialogDeleteDepbranchjobComponent } from './dialog-delete-depbranchjob/dialog-delete-depbranchjob.component';
import { DialogLoanActionComponent } from './dialog-loan-action/dialog-loan-action.component';
import { DialogDeletePayrollConceptComponent } from './dialog-delete-payroll-concept/dialog-delete-payroll-concept.component';
import { DialogDeleteHolidayComponent } from './dialog-delete-holiday/dialog-delete-holiday.component';
import { DialogAddAccessComponent } from './dialog-add-access/dialog-add-access.component';
import { DialogDeleteAccessComponent } from './dialog-delete-access/dialog-delete-access.component';
import { DialogViewDepartmentsComponent } from './dialog-view-departments/dialog-view-departments.component';
import { DialogAddDepartmentComponent } from './dialog-add-department/dialog-add-department.component';
import { DialogAddTicketComponent } from './dialog-add-ticket/dialog-add-ticket.component';
import { DialogEulaComponent } from './dialog-eula/dialog-eula.component';
import { DialogDeleteConfigComponent } from './dialog-delete-config/dialog-delete-config.component';
import { DialogDeleteElementComponent } from './dialog-delete-element/dialog-delete-element.component';
import { DialogAddElementComponent } from './dialog-add-element/dialog-add-element.component';
import { DialogDeleteElementBatchComponent } from './dialog-delete-element-batch/dialog-delete-element-batch.component';
import { DialogDeleteChargeComponent } from './dialog-delete-charge/dialog-delete-charge.component';
import { DialogDeleteScaleComponent } from './dialog-delete-scale/dialog-delete-scale.component';
import { DialogDeleteScaleBatchComponent } from './dialog-delete-scale-batch/dialog-delete-scale-batch.component';
import { DialogAddScalelineComponent } from './dialog-add-scaleline/dialog-add-scaleline.component';
import { ModalImportChargeComponent } from './modal-import-charge/modal-import-charge.component';
import { ModalImportScaleComponent } from './modal-import-scale/modal-import-scale.component';
import { ModalImportScalelineComponent } from './modal-import-scaleline/modal-import-scaleline.component';
import { ModalImportScaleCombinedComponent } from './modal-import-scale-combined/modal-import-scale-combined.component';
import { ModalImportConceptCagetoryComponent } from './modal-import-concept-cagetory/modal-import-concept-cagetory.component';
import { ModalImportConceptCatalogComponent } from './modal-import-concept-catalog/modal-import-concept-catalog.component';
import { ModalImportDepartmentComponent } from './modal-import-department/modal-import-department.component';
import { ModalImportBranchComponent } from './modal-import-branch/modal-import-branch.component';
import { ModalImportJobComponent } from './modal-import-job/modal-import-job.component';
import { ModalImportHolidayComponent } from './modal-import-holiday/modal-import-holiday.component';
import { ModalImportDefinitionConceptsComponent } from './modal-import-definition-concepts/modal-import-definition-concepts.component';
import { ModalImportConfigComponent } from './modal-import-config/modal-import-config.component';
import { ModalImportElementComponent } from './modal-import-element/modal-import-element.component';
import { ModalImportElementValueComponent } from './modal-import-element-value/modal-import-element-value.component';
import { DialogSendLeavesComponent } from './dialog-send-leaves/dialog-send-leaves.component';
import { ModalEmployeeXenditComponent } from './modal-employee-xendit/modal-employee-xendit.component';
import { DialogWorkdaysRequestsComponent } from './dialog-workdays-requests/dialog-workdays-requests.component';
import { DialogAddDefaultscheduleComponent } from './dialog-add-defaultschedule/dialog-add-defaultschedule.component';
import { DialogDeleteDefaultscheduleComponent } from './dialog-delete-defaultschedule/dialog-delete-defaultschedule.component';
import { DialogDeleteDefaultscheduleBatchComponent } from './dialog-delete-defaultschedule-batch/dialog-delete-defaultschedule-batch.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { ModalImportDefaultScheduleComponent } from './modal-import-default-schedule/modal-import-default-schedule.component';
import { ModalImportDefaultSchedulelineComponent } from './modal-import-default-scheduleline/modal-import-default-scheduleline.component';
import { DialogProcessImporttimesheetComponent } from './dialog-process-importtimesheet/dialog-process-importtimesheet.component';
import { DialogProcessTimesheetComponent } from './dialog-process-timesheet/dialog-process-timesheet.component';
import { DialogProcessPayrollComponent } from './dialog-process-payroll/dialog-process-payroll.component';
import { DialogProcessInvoiceComponent } from './dialog-process-invoice/dialog-process-invoice.component';
import { DialogChangePlanComponent } from './dialog-change-plan/dialog-change-plan.component';
import { DialogImportDatComponent } from './dialog-import-dat/dialog-import-dat.component';
import { DialogDeleteProcessComponent } from './dialog-delete-process/dialog-delete-process.component';
import { DialogPassConfirmComponent } from './dialog-pass-confirm/dialog-pass-confirm.component';
import { DialogESignComponent } from './dialog-e-sign/dialog-e-sign.component';
import { DialogDeletePayrollProcessComponent } from './dialog-delete-payroll-process/dialog-delete-payroll-process.component';
import { DialogDocActionComponent } from './dialog-doc-action/dialog-doc-action.component';
import { DialogDeleteDeductionComponent } from './dialog-delete-deduction/dialog-delete-deduction.component';
import { AddPayrollLineDialogComponent } from './add-payroll-line-dialog/add-payroll-line-dialog.component';
import { DialogDeletePayrolllineComponent } from './dialog-delete-payrollline/dialog-delete-payrollline.component';
import { DialogDocActionPayrollComponent } from './dialog-doc-action-payroll/dialog-doc-action-payroll.component';
import { DialogProcessWorkdaysComponent } from './dialog-process-workdays/dialog-process-workdays.component';
import { ReasonDialogComponent } from './reason-dialog/reason-dialog.component';
import { DialogEditWorkdaysComponent } from './dialog-edit-workdays/dialog-edit-workdays.component';
import { TableSettingsDialogComponent } from './table-settings-dialog/table-settings-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DialogAddMenuAccessComponent } from './dialog-add-menu-access/dialog-add-menu-access.component';
import { DialogDeleteComponent } from './dialog-delete/dialog-delete.component';
import { DialogAddBroadcastComponent } from './dialog-add-broadcast/dialog-add-broadcast.component';
import { ConfirmationDialogComponent } from 'app/core/services/confirmation.dialog';
import { AddLeaveDialogComponent } from './add-leave-dialog/add-leave-dialog.component';
import { DialogProcessImportTimesheetComponent } from './dialog-process-import-timesheet/dialog-process-import-timesheet.component';
import { DialogEditTimeEntryComponent } from './dialog-edit-time-entry/dialog-edit-time-entry.component';
import { ModalImportTimeentriesComponent } from './modal-import-timeentries/modal-import-timeentries.component';
import { DialogEditLoanLineComponent } from './dialog-edit-loan/dialog-edit-loan-line.component';
import {MatDividerModule} from '@angular/material/divider';
import { AddWeekScheduleDialogComponent } from './add-week-schedule-dialog/add-week-schedule-dialog.component';
import { DialogCreateWorkdayComponent } from './dialog-create-workday/dialog-create-workday.component';
import { DialogDeleteAdjustmentComponent } from './dialog-delete-adjustment/dialog-delete-adjustment.component';
import { TourOverlayComponent } from './tour-overlay/tour-overlay.component';
import { DialogProcessAllComponent } from './dialog-process-all/dialog-process-all.component';
import { ModalImportDeductionComponent } from './modal-import-deduction/modal-import-deduction.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    WebcamModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatStepperModule,
    AsyncPipe,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatChipsModule,
    DragDropModule,
    MatDividerModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    DialogComponent,
    GenTimesheetDialogComponent,
    DialogDevicesComponent,
    DialogLeaveComponent,
    DialogEmployeeTimesheetComponent,
    DialogPaidLoanComponent,
    DialogExpenseComponent,
    DialogEmployeeDeleteComponent,
    DialogEmployeeDetailsComponent,
    DialogRemittSsoComponent,
    ModalImportEmployeeComponent,
    ModalPlanRenewComponent,
    AlertComponent,
    DialogDefinitionComponent,
    DialogAddConceptsComponent,
    DialogDeleteConceptComponent,
    DialogAddYearComponent,
    DialogDeleteYearComponent,
    DialogCreatePeriodsComponent,
    DialogDeleteYearBatchComponent,
    DialogDeleteDepbranchjobComponent,
    DialogLoanActionComponent,
    DialogDeletePayrollConceptComponent,
    DialogDeleteHolidayComponent,
    DialogAddAccessComponent,
    DialogDeleteAccessComponent,
    DialogViewDepartmentsComponent,
    DialogAddDepartmentComponent,
    DialogAddTicketComponent,
    DialogEulaComponent,
    DialogDeleteConfigComponent,
    DialogDeleteElementComponent,
    DialogAddElementComponent,
    DialogDeleteElementBatchComponent,
    DialogDeleteChargeComponent,
    DialogDeleteScaleComponent,
    DialogDeleteScaleBatchComponent,
    DialogAddScalelineComponent,
    ModalImportChargeComponent,
    ModalImportScaleComponent,
    ModalImportScalelineComponent,
    ModalImportScaleCombinedComponent,
    ModalImportConceptCagetoryComponent,
    ModalImportConceptCatalogComponent,
    ModalImportDepartmentComponent,
    ModalImportBranchComponent,
    ModalImportJobComponent,
    ModalImportHolidayComponent,
    ModalImportDefinitionConceptsComponent,
    ModalImportConfigComponent,
    ModalImportElementComponent,
    ModalImportElementValueComponent,
    DialogSendLeavesComponent,
    ModalEmployeeXenditComponent,
    DialogWorkdaysRequestsComponent,
    DialogAddDefaultscheduleComponent,
    DialogDeleteDefaultscheduleComponent,
    DialogDeleteDefaultscheduleBatchComponent,
    ModalImportDefaultScheduleComponent,
    ModalImportDefaultSchedulelineComponent,
    DialogProcessImporttimesheetComponent,
    DialogProcessTimesheetComponent,
    DialogProcessPayrollComponent,
    DialogProcessInvoiceComponent,
    DialogChangePlanComponent,
    DialogImportDatComponent,
    DialogDeleteProcessComponent,
    DialogPassConfirmComponent,
    DialogESignComponent,
    DialogDeletePayrollProcessComponent,
    DialogDocActionComponent,
    DialogDeleteDeductionComponent,
    AddPayrollLineDialogComponent,
    DialogDeletePayrolllineComponent,
    DialogDocActionPayrollComponent,
    DialogProcessWorkdaysComponent,
    ReasonDialogComponent,
    DialogEditWorkdaysComponent,
    TableSettingsDialogComponent,
    DialogAddMenuAccessComponent,
    DialogDeleteComponent,
    DialogAddBroadcastComponent,
    ConfirmationDialogComponent,
    AddLeaveDialogComponent,
    DialogProcessImportTimesheetComponent,
    DialogEditTimeEntryComponent,
    ModalImportTimeentriesComponent,
    DialogEditLoanLineComponent,
    AddWeekScheduleDialogComponent,
    DialogCreateWorkdayComponent,
    TabBarComponent,
    DialogDeleteAdjustmentComponent,
    TourOverlayComponent,
    DialogProcessAllComponent,
    ModalImportDeductionComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AlertComponent,
    TabBarComponent,
    TourOverlayComponent,
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: false },
    },
  ],
})
export class ComponentsModule { }
